var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6 0C14.9255 0 16 1.07452 16 2.4V13.6C16 14.9255 14.9255 16 13.6 16H2.4C1.07452 16 0 14.9255 0 13.6V2.4C0 1.07452 1.07452 0 2.4 0H13.6ZM14.4 11.2H1.6V13.6C1.6 14.0103 1.90882 14.3484 2.30669 14.3946L2.4 14.4H13.6C14.0418 14.4 14.4 14.0418 14.4 13.6V11.2ZM14.4 6.4H1.6V9.6H14.4V6.4ZM13.6 1.6H2.4C1.95817 1.6 1.6 1.95817 1.6 2.4V4.8H14.4V2.4C14.4 1.98973 14.0912 1.65158 13.6933 1.60537L13.6 1.6Z",
    fill: "var(--fill-0, #6A7D80)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetList);
export default __webpack_public_path__ + "static/media/asset-list.5e7001a716300775f444092e97f8a44a.svg";
export { ForwardRef as ReactComponent };